import uibPagination from 'angular-ui-bootstrap/src/pagination';
import paginateDirective from './paginateDirective';
// ui bootstrap pagination plugin

export default angular.module('relayComps.pagination', [uibPagination]).directive('relayPaginate', paginateDirective).name;
